import React from "react";
import "../css/footer.css";

const Footer = () => (
  <footer className="footer">
    <div className="bottom">"Clickly Game!"</div>
  </footer>
);

export default Footer;
